exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.location-header[data-v-40b4e212] {\n  width: 100%;\n  height: 40vh;\n}\n", ""]);

// exports
